import React from 'react';
import { useTranslation } from 'react-i18next';
import * as authSelector from '../../../store/selectors/authSelectors';
import { useSelector } from 'react-redux';
// components
import HeaderCorner from './HeaderCorner';
import useLanguage from '../../common/useLanguage';
import useLogout from '../../common/useLogout';
// assets / style
import {
  ActionItem,
  Actions,
  AppContainer,
  BaseItem,
  Container,
  LogoContainer,
  NavBarOptions,
  TextItem,
  ZikaronLogo
} from "./style";
import zikaronLogo from "../../../assets/icons/zikaronLogo.svg";
import zikaronLogoEng from "../../../assets/icons/zikaronLogoEng.svg";
import NavBarActions from "./NavBarActions";
import { Link, withRouter } from "react-router-dom";
import ButtonSmall from "../../common/ButtonSmall";
import { adminUsers } from '../../../utils/constants/usersTypes';
import { colorGrey, colorBackground, colorLightYellow } from '../../../utils/css/colors';
import * as guestsSelectors from "../../../store/selectors/guestsSelectors";
import * as hostSelectors from "../../../store/selectors/hostsSelectors";
import LanguageToggle from '../../common/LanguageToggle/LanguageToggle';
import NavBarActionsHost from './NavBarActionHost';

const Desktop = ({ history }) => {
  const {
    t,
    i18n: { language }
  } = useTranslation();
  const logout = useLogout();

  const firstName = useSelector(authSelector.firstNameSelector);
  const lastName = useSelector(authSelector.lastNameSelector);
  const role = useSelector(authSelector.roleSelector);
  const token = useSelector(authSelector.tokenSelector);
  const guestId = useSelector(guestsSelectors.guestIdSelector);
  const hostId = useSelector(hostSelectors.hostIdSelector);
  const guestProfile = useSelector(guestsSelectors.guestProfileSelector);
  const fullName = (guestProfile?.first_name && guestProfile?.last_name)
    ? `${guestProfile.first_name} ${guestProfile.last_name}`
    : (firstName && lastName) ? `${firstName} ${lastName}` :
      t(`admin.header.userItems.${role}`);

  const [selectedLanguage, onLangugageChange] = useLanguage();
  const locationForHeader = window.location.href.split("site")?.[1];
  return (
    <>
      {locationForHeader === `/guest/${guestId}/salon` ||
        locationForHeader === `/guest/${guestId}/profile` ||
        locationForHeader === `/guest/${guestId}/profile/profile` ||
        locationForHeader === `/guest/${guestId}/profile/salon` ? (
        <AppContainer dir={language === "he" ? "rtl" : "ltr"}>
          <Actions>
            <LogoContainer
              href={
                role === "guest" || role === "host" || role === "witness"
                  ? language === "he" ? "https://www.zikaronbasalon.com/" : "http://www.zikaronbasalon.com/en/"
                  : "https://app.zikaronbasalon.com/admin"
              }
            >
              <ZikaronLogo src={language === "he" ? zikaronLogo : zikaronLogoEng} alt="logo"></ZikaronLogo>
            </LogoContainer>
            <BaseItem>{`${t("admin.header.userItems.greetings")} ${token && fullName
              }`}</BaseItem>
            <NavBarOptions>
              <NavBarActions history={history} />
            </NavBarOptions>
          </Actions>
          <Actions>
            <ActionItem clickable onClick={logout}>
              {token
                ? t("admin.header.userItems.logout")
                : t("admin.header.userItems.login")}
            </ActionItem>
            <LanguageToggle />
          </Actions>
        </AppContainer>
      ) : (
        <AppContainer dir={language === "he" ? "rtl" : "ltr"}>
          <Actions>
            <LogoContainer
                href={
                  role === "guest" || role === "host" || role === "witness"
                    ? language === "he" ? "https://www.zikaronbasalon.com/" : "http://www.zikaronbasalon.com/en/"
                    : "https://app.zikaronbasalon.com/admin"
                }
            >
              <ZikaronLogo src={language === "he" ? zikaronLogo : zikaronLogoEng} alt="logo"></ZikaronLogo>
            </LogoContainer>
          </Actions>
          {token ? 
          <Actions>
            <ButtonSmall
              width={130}
              height={"54px"}
              colorType={"white"}
              colorProps={"black"}
              borderProps={"1px solid black"}
              position={"relative"}
              fontSize={"16px"}
            >
             
              <Link
                to={`/site/${role}/${role === "guest" ? guestId : hostId}/salon`}
                style={{ color: "black" }}
              >
                {t('host.exit')}
              </Link>
            </ButtonSmall>
          </Actions>
          : <LanguageToggle/>
          }
        </AppContainer>
      )}
    </>
  );
};

export default withRouter(Desktop);
